import React, { useState } from "react";
import {
  ReferenceManyField,
  Query,
  RichTextField,
  ShowButton,
  TabbedShowLayout, SimpleShowLayout, Responsive, GET_ONE,
  Tab,
  CardActions,
  Show,
  NumberField,
  List,
  FunctionField,
  Datagrid,
  TextField,
  Pagination,
  ReferenceField,
  DateField,
  BooleanInput,
  Button,
  Link,
  EditButton,
  DeleteButton,
  GET_LIST,
} from "react-admin";
import dataProviderFactory from "../dataProvider";
import DeleteButtonWithConfirmation from "../components/DeleteButtonWithConfirmation";
import styles from "../components/dashboard/Styles";
import ReactToPrint from 'react-to-print';
import Print from "@material-ui/icons/Print";
import moment from "moment";
import {
  join,
  filter,
  identity,
  map,
  prop,
  compose,
  juxt,
  toUpper,
  head,
  tail,
  isNil,
  isEmpty,
  propEq,
  path,
} from "ramda";

import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import { TextBooleanField } from "../components/TextBooleanField";
import CheckBlackList from "../components/checkBlackList";
import { isNull } from "util";
import TourBookingFormButton from "../components/tourBookingForm";
import { getPermissionRole } from "../util";
import { getCountryByID } from "../util";

const getRowColor = (record) => {
  if(record.blacklist) {
    return "#FF6666";
  }
  
  return "";
};

const rowStyle = (record, index) => ({
  backgroundColor: getRowColor(record),  
});

const StyledGridHeader = styled(Grid)({
  padding: "5px",
  backgroundColor: "#ff9800",
  color: "#000000",
  textTransform: "uppercase",
});

const StyledGridElement = styled(Grid)({
  padding: "5px",
  color: "#000000",
  fontSize: "13px",
});

const ListPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const shirtSize = { 1: "S (EU) | XS (US)", 2: "M (EU) | S (US)", 3: "L (EU) | M (US)", 4: "XL (EU) | L (US)", 5: "XXL (EU) | XL (US)", 6: "XXXL (EU) | XXL (US)" };

const ProcessButton = (props) => (
  <Button
    component={Link}
    to={{
      pathname: `/rental_due/${props.record.id}`,
    }}
    label="Process"
  />
);

export const ToursDueList = (props) => (
  <List
    {...props}
    title="Tours Due"
    resource="rentals_due"
    pagination={<ListPagination/>}
    bulkActionButtons={false}
    filter={{ type: 2 }}
  >
    <Datagrid>
      <TextField label="Tour rent ID" source="id" />

      <ReferenceField
        label="Client"
        source="booking_id"
        reference="bookings"
        linkType={false}
      >
        <FunctionField
          render={(booking) =>
            `${booking.r_first_name} ${booking.r_last_name}`
          }
        />
      </ReferenceField>
      <BooleanInput label="P4M" source="booking.p4m" />
      <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} label="Pick-up Date" source="date_1" />
      <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} label="Drop-off Date" source="date_2" />

      <ReferenceField
        label="Bike"
        source="choice"
        reference="vehicle_models"
        linkType={false}
      >
        <TextField source="model_name" />
      </ReferenceField>

      <ReferenceField
        label="Pick-up city"
        source="location_id_1"
        reference="locations"
        linkType={false}
      >
        <TextField source="location_name" />
      </ReferenceField>

      <ReferenceField
        label="Drop-off city"
        source="location_id_2"
        reference="locations"
        linkType={false}
      >
        <TextField source="location_name" />
      </ReferenceField>

      <FunctionField
        label="Days to rental"
        source="date_1"
        render={(rental) => {
          return `${Math.floor(
            moment
              .duration(moment(rental.date_1).diff(moment()))
              .as("days", true)
          )} days`;
        }}
      />

      <NumberField source="value_due" options={{ maximumFractionDigits: 2 }} />

      <ProcessButton />
    </Datagrid>
  </List>
);
export const PendingTourBookingsList = (props) => {
  return (
    <List
      {...props}
      title="Pending Tour Bookings"
      resource="pending_rentals"
      bulkActionButtons={false}
      pagination={false}
      filter={{ type: 1 }}
    >
      <Datagrid rowStyle={rowStyle}>
        <TextField label="Tour rent ID" source="id" />
        <TextField label="Booking ID" source="booking_id" />

        <ReferenceField
          label="TourName"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <ReferenceField source="tour_id" reference="tours" linkType={false}>
            <ReferenceField
              source="tour_name_id"
              reference="tour_names"
              linkType={false}
            >
              <TextField source="tour_name_en" />
            </ReferenceField>
          </ReferenceField>
        </ReferenceField>

        <ReferenceField
          label="P4M"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <TextBooleanField label="P4M" source="p4m" />
        </ReferenceField>

        <ReferenceField
          label="Tour Start Date"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <ReferenceField source="tour_id" reference="tours" linkType={false}>
            <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} source="tour_start_date" />
          </ReferenceField>
        </ReferenceField>

        <ReferenceField
          label="Client"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <FunctionField
            render={(booking) =>
              `${booking.r_first_name} ${booking.r_last_name}`
            }
          />
        </ReferenceField>

        <ReferenceField
          label="Submitted"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} source="r_timestamp" />
        </ReferenceField>
        <ShowButton basePath="tour_management" label="Details" />

        {([1, 2, 4, 6, 9].includes(getPermissionRole())) && ( 
          <DeleteButtonWithConfirmation basePath="tour_management" label="Cancel Book Tour" />
        )}
        {/* <DeleteButton basePath="pending_tours" label="Cancel Booking" /> */}
      </Datagrid>
    </List>    
  )


};

const cardActionStyle = {
  zIndex: 2,
 // display: "inline-block",
  float: "right",
};

const PendingRentalShowActions = ({ basePath, data, resource }) => {
  console.log(data)
  let booking
  if(data!= undefined)
   booking = data.booking_id
  else 
    booking = 0
  return (
  <CardActions style={cardActionStyle}>
     <TourBookingFormButton bookingId={booking} />
    {/* <EditButton basePath={basePath} record={data} label="Process" /> */}
    <EditButton basePath="/process_tour" record={data} label="Process" />
   
  </CardActions>
)};

const isBeforeToday = (t) => {
  return (
    !isNil(t.booking.tour) &&
    moment(t.booking.tour.tour_end_date).isBefore(moment())
  );
};

const renderTours = (client) => {
  const toursDone = filter(isBeforeToday, client.rentals);
console.log(toursDone.vehicle);
  if (!isEmpty(toursDone)) {
    return (
      <React.Fragment>
        <Grid container spacing={0}>
          <Grid container spacing={0} xs={12}>
            <StyledGridHeader item xs={1}>
              Id
            </StyledGridHeader>
            <StyledGridHeader item xs={5}>
              Tour
            </StyledGridHeader>
            <StyledGridHeader item xs={2}>
              First Name
            </StyledGridHeader>
            <StyledGridHeader item xs={2}>
              Last Name
            </StyledGridHeader>
            <StyledGridHeader item xs={2}>
              Vehicle
            </StyledGridHeader>
          </Grid>
          {map((rental) => {
            return (
              <Grid container spacing={0} xs={12}>
                <StyledGridElement item xs={1}>
                  {rental.id}
                </StyledGridElement>
                <StyledGridElement item xs={5}>
                  {rental.booking.tour.tour_name.tour_name_en} --{" "}
                  {moment(rental.booking.tour.tour_start_date).format("MMM D")}-
                  {moment(rental.booking.tour.tour_end_date).format("D YYYY")}
                </StyledGridElement>
                <StyledGridElement item xs={2}>
                  {rental.booking.r_first_name}
                </StyledGridElement>
                <StyledGridElement item xs={2}>
                  {rental.booking.r_last_name}
                </StyledGridElement>
                <StyledGridElement item xs={2}>
                  {head(rental.vehicle) !== undefined ? head(rental.vehicle).model.model_name : "Own Motorcycle"} -{" "}
                  {head(rental.vehicle) !== undefined ? head(rental.vehicle).licence_plate : "N/A"}
                </StyledGridElement>
              </Grid>
            );
          }, toursDone)}
        </Grid>
      </React.Fragment>
    );
  }
  return "";
};

const getAllPrcices = async (for_tour_id, priceDate) => {
  const dataProvider = await dataProviderFactory("rest");
  const response = await dataProvider(GET_LIST, "prices", {
    filter: {
      for_date: priceDate,
      for_tour_id: for_tour_id,
    },
    pagination: {
      page: 1,
      perPage: 99999,
    },
    sort: {}
  });

  return response.data;
};

const getTotals = async (rental) => {
  const tour = rental.booking.tour;
  const data = rental.booking;

  let gpsPrice = 0;
  let singlePrice = 0;
  let vipInsurancePrice = 0;
  let cancelInsurancePercentage = 0;
  let cancelInsuranceValue1 = 0;
  let cancelInsuranceValue2 = 0;
  let model1Price = 0;
  let model2Price = 0;
  let tourDays = 0;
  let tourTotal1 = 0;
  let tourPrice1 = 0;
  let tourPrice2 = 0;
  let tourTotal2 = 0;
  let passengerPrice = 0;
  let passengerRegularPrice = 0;
  let { rewards } = rental.booking || 0;

  tourDays = moment(tour.effective_end_date).diff(
    moment(tour.effective_start_date),
    "days"
  );

  const response = await getAllPrcices(tour.id, data.price_date);
  model2Price =
    prop(
      "price",
      head(
        filter(
          propEq("price_item_sub_type", `tour_${data.model_2.upgrade_type}`),
          response
        )
      )
    ) || 0;

  model1Price =
    prop(
      "price",
      head(
        filter(
          propEq("price_item_sub_type", `tour_${data.model_1.upgrade_type}`),
          response
        )
      )
    ) || 0;

  const gpsFilter = filter(
    propEq("price_item_type", "gps_device"),
    data.prices
  );

  if(gpsFilter.length > 0) {
    gpsPrice = data.r_gps
      ? prop(
        "price",
        head(filter(propEq("price_item_type", "gps_device"), data.prices))
      )
      : 0;
  }

  singlePrice = data.r_single
    ? prop(
      "price",
      head(filter(propEq("price_item_sub_type", "tour_single"), data.prices))
    )
    : 0;

  passengerRegularPrice = prop(
    "price",
    head(filter(propEq("price_item_sub_type", "tour_passenger"), response))
  );

  passengerPrice = !isNull(rental.booking.p_first_name)
    ? prop(
      "price",
      head(filter(propEq("price_item_sub_type", "tour_passenger"), response))
    )
    : 0;

  tourPrice1 =
    rental.booking.model_1.model_name === "Own Motorcycle"
      ? passengerRegularPrice + 500
      : prop(
        "price",
        head(filter(propEq("price_item_sub_type", "tour_total"), data.prices))
      );

  tourPrice2 =
    rental.booking.model_2.model_name === "Own Motorcycle"
      ? passengerRegularPrice + 500
      : prop(
        "price",
        head(filter(propEq("price_item_sub_type", "tour_total"), data.prices))
      );

  vipInsurancePrice = data.r_insurance
    ? prop(
      "price",
      head(
        filter(
          propEq("price_item_id", 1),
          filter(propEq("price_item_type", "insurance"), data.prices)
        )
      )
    )
    : 0;

  cancelInsurancePercentage = data.r_cancel_insurance
    ? prop(
      "percentage",
      head(
        filter(
          propEq("price_item_id", 3),
          filter(propEq("price_item_type", "insurance"), data.prices)
        )
      )
    )
    : 0;

  cancelInsuranceValue1 = data.r_cancel_insurance
    ? ((tourPrice1 +
      gpsPrice * tourDays +
      passengerPrice +
      singlePrice +
      model1Price) *
      cancelInsurancePercentage) /
    100
    : 0;

  tourTotal1 =
    cancelInsuranceValue1 +
    (tourPrice1 +
      gpsPrice * tourDays +
      vipInsurancePrice * tourDays +
      passengerPrice +
      singlePrice +
      model1Price) -
    rewards;

  cancelInsuranceValue2 = data.r_cancel_insurance
    ? ((tourPrice2 +
      gpsPrice * tourDays +
      passengerPrice +
      singlePrice +
      model2Price) *
      cancelInsurancePercentage) /
    100
    : 0;

  tourTotal2 =
    cancelInsuranceValue2 +
    (tourPrice2 +
      gpsPrice * tourDays +
      vipInsurancePrice * tourDays +
      passengerPrice +
      singlePrice +
      model2Price) -
    rewards;

  return {
    total1: tourTotal1.toFixed(2),
    total2: tourTotal2.toFixed(2),
  };
};
const PastImtbTours = (object) => {
 
  if (isNil(object)) {
    return "";
  }
  return (
    <FunctionField
      label="Past IMTB Tours"
      render={(rental) => (
        <Query
          type="GET_ONE"
          resource="clients"
          payload={{ id: object.record.driver.id }}
        >
          {({ data, error }) => {
            if (error) {
              return <p>ERROR</p>;
            }
            if (!isNil(data)) {
              return renderTours(data);
            } else {
              return "";
            }
          }}
        </Query>
      )}
    />
  );
};

const componentRef = React.createRef();

export const PendingTourShow = (props) => {
  return (
    <Show {...props} actions={<PendingRentalShowActions {...props}/>} title="Tour (ID)">
      <SimpleShowLayout>
        <ReactToPrint
          trigger={() => (
            <Button color="primary" label="Print">
              <Print />
            </Button>
          )}
          content={() => componentRef.current}
        />
        <FunctionField id="react-no-print" ref={componentRef}
          label=" "
          render={(rental) => {
            //console.log(rental)
            return DetalleTour(rental);
          }}
        />
      </SimpleShowLayout>
    </Show>
  );
};

let array = []

async function getModels(id, key) {
  const dataProvider = await dataProviderFactory("rest");
  const models = await dataProvider(GET_ONE, "vehicle_models", { id })
  //console.log(models)
  array.push(models.data)
  if (key === 1)
    document.getElementById('model1').innerHTML = `${models.data.model_name} (first choice)`
  if (key === 2)
    document.getElementById('model2').innerHTML = ` - ${models.data.model_name}  (second choice)`
  let newrowLocation = JSON.stringify(models)
  let objetoLocation = JSON.parse(newrowLocation);
  return objetoLocation;
}
let countries = []
async function getCountry(id, key) {
  const dataProvider = await dataProviderFactory("rest");
  const models = await dataProvider(GET_ONE, "countries", { id })
  //console.log(models)
  array.push(models.data)
  if (key === 1)
    document.getElementById('countryD').innerHTML = `${models.data.country}`
  if (key === 2)
    document.getElementById('country2').innerHTML = `${models.data.country}`

  if (key === 3) {
    debugger;
    if(typeof(id) !== "number"){
        const nationalityElement = document.getElementById('nationalityD');
        if (nationalityElement) {
          nationalityElement.innerHTML = `${id}`;
        }
      return id;  
    }
    else{  
      document.getElementById('nationalityD').innerHTML = `${models.data.country}`
    }
  }
  let newrowLocation = JSON.stringify(models)
  let objetoLocation = JSON.parse(newrowLocation);
  return objetoLocation;
}
async function getTourName(id) {
  const dataProvider = await dataProviderFactory("rest");
  const tourname = await dataProvider(GET_ONE, "tour_names", { id })

  array.push(tourname.data)
  let tourD = document.getElementById('tourD') 
  tourD.innerHTML = `${tourname.data.tour_name_en}`
  let newrowLocation = JSON.stringify(tourname)
  let objetoLocation = JSON.parse(newrowLocation);
  return objetoLocation;
}
async function getTour(id, key) {
  const dataProvider = await dataProviderFactory("rest");
  const models = await dataProvider(GET_ONE, "tours", { id })
  let tourIDName = models.data.tour_name_id
  getTourName(tourIDName)
  let newrowLocation = JSON.stringify(models)
  let objetoLocation = JSON.parse(newrowLocation);
  return objetoLocation;
}

function GetRefe(rental) {
  const ref = rental.driver.referral
  return ref;
}

const DetalleTour = (rental) => (
  <React.Fragment>
    <Responsive
      medium={
        <div class="fullwith" style={styles.flexPadding}>  
            <CheckBlackList record={rental} />
          <h3 class="colorTitleP">TOUR BOOKING FORM ({`${rental.id}`})</h3> 
          <div id="padreForm" style={styles.flex}>
            <div style={styles.leftColB}>
              <div class="minusPadd" style={styles.flexB}>
                <h2 class="colorTitle">Tour summary</h2>
              </div>
              <div style={styles.flexB}>
                <FunctionField
                  label="TourName"
                  render={(d) => {
                    const idTour = rental.booking.tour
                    getTour(idTour.id, 1)
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Tour name: </label>
                      <span id="tourD" class="boldDetalle tamDetalle2">{` `} </span>
                    </React.Fragment>
                  }}
                />
              </div>
              <div style={styles.flexB}>
                <FunctionField
                  label="P4M"
                  render={(d) => {
                    if (!rental.booking.p4m) {
                      return <React.Fragment>
                        <label class="colorDetalle tamDetalle">P4M: </label> <span class="tamDetalle2">No    </span>
                      </React.Fragment>
                    }
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">P4M: </label> <span class="tamDetalle2">Yes    </span>
                    </React.Fragment>
                  }}
                />
              </div>
              <br />
              <div style={styles.flexB}>
                <FunctionField
                  label="Tour Start Date"
                  render={(d) => {
                    const idTour = rental.booking.tour
                    const date = moment(idTour.tour_start_date);

                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Tour start date: </label>
                      <span class="boldDetalle tamDetalle2">{`${date.format("MMMM D, YYYY")}`} </span>
                    </React.Fragment>
                  }}
                />
              </div>  <br />
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Passenger"
                          render={(b) => {
                            if (isNil(rental.booking.p_first_name)) {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle">Passenger: </label>
                                <span class="tamDetalle2">{`No`} </span>
                              </React.Fragment>
                            }
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Passenger: </label>
                              <span class="tamDetalle2">{`${rental.booking.p_first_name} ${rental.booking.p_last_name}`} </span>
                            </React.Fragment>
                          }}
                        />
                      </div>  <br />
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Roommate name"
                          render={(b) => {
                            if (isNil(rental.booking.roommate) || rental.booking.roommate === '') {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle">Roommate name: </label>
                                <span class="tamDetalle2">{`No`} </span>
                              </React.Fragment>
                            }
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Roommate name: </label>
                              <span class="tamDetalle2">{`${rental.booking.roommate}`} </span>
                            </React.Fragment>
                          }}
                        />
                      </div> <br />
                    </div>
                  </div>
                </div>
              </div>
              <div style={styles.flexB}>
                <FunctionField
                  label="First Choice Bike"
                  render={(d) => {
                    getModels(rental.booking.vehicle_model_1, 1)
                    getModels(rental.booking.vehicle_model_2, 2)
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Motorcycle: </label>
                      <span id="model1" class="boldDetalle tamDetalle2">{` `} </span>
                      <span class="tamDetalle2" id="model2">{` `}</span>
                      {/* <span class="boldDetalle"> (first choice) </span> */}
                    </React.Fragment>
                  }}
                /> 
              </div> <br />
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="GPS"
                          render={(d) => {
                            if (!rental.booking.r_gps) {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle">GPS: </label> <span class="tamDetalle2">No    </span>
                              </React.Fragment>
                            }
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">GPS: </label> <span class="tamDetalle2">Yes    </span>
                            </React.Fragment>
                          }}
                        />
                      </div><br />
                      <div style={styles.flexB}>
                        <FunctionField
                          label="VIP Insurance"
                          render={(d) => {
                            if (!rental.booking.r_insurance) {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle">VIP Insurance: </label> <span class="tamDetalle2">No    </span>
                              </React.Fragment>
                            }
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">VIP Insurance: </label> <span class="tamDetalle2">Yes    </span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Single"
                          render={(d) => {
                            if (!rental.booking.r_single) {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle">Single: </label> <span class="tamDetalle2">No    </span>
                              </React.Fragment>
                            }
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Single: </label> <span class="tamDetalle2">Yes    </span>
                            </React.Fragment>
                          }}
                        />
                      </div>  <br />
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Rewards Used"
                          render={(d) => {
                            return <React.Fragment>
                              <label class="colorTitle">IMT rewards: </label> <span class="tamDetalle2">{`${rental.booking.rewards} points`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Cancel Insurance"
                          render={(d) => {
                            if (!rental.booking.r_cancel_insurance) {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle">Cancel insurance: </label> <span class="tamDetalle2">No    </span>
                              </React.Fragment>
                            }
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Cancel insurance: </label> <span class="tamDetalle2">Yes    </span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div> <br />
                  </div><br />
                </div>
              </div>
              <div class="minusPadd" style={styles.flexB}>
                <h2 class="colorTitle">Rental cost:</h2>
              </div>
              <div style={styles.flexB}>
                <FunctionField
                  label="Total Price for First Choice Bike"
                  render={(b) => {
                    let [total1, setTotal1] = useState(0);

                    const handleRental = async (rental) => {
                      const { total1 } = await getTotals(rental);

                      setTotal1(total1);
                    };
                    handleRental(rental);
                    let deposit = (total1 * 0.3).toFixed(2)
                    let depositText = ''
                    
                    let dayActual = moment(Date.now()).format("YYYY-MM-DD")
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Price for first choice bike: </label>
                        <span class="boldDetalle tamDetalle2">
                         {`${total1} €.`}
                       </span> 
                    </React.Fragment>
                    //return `${total1} €`;
                  }}
                />
              </div>
              <div style={styles.flexB}>
                <FunctionField
                  label="Total Price for Second Choice Bike"
                  render={(b) => {
                    let [total2, setTotal2] = useState(0);
                    const handleRental = async (rental) => {
                      const { total2 } = await getTotals(rental);
                      setTotal2(total2);
                    };
                    handleRental(rental);
                    let deposit = (total2 * 0.3).toFixed(2)
                    let depositText = ''
                    let dayActual = moment(Date.now()).format("YYYY-MM-DD")
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Price for second choice bike: </label>
                       <span class="boldDetalle tamDetalle2">
                         {`${total2} €.`}
                       </span>
                    </React.Fragment>
                  }}
                />
              </div> <br />
              <div style={styles.flexB}>
                <FunctionField
                  label="Credit card"
                  render={(b) => {
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Credit card: </label>
                      <span class="tamDetalle2">{`${rental.clientData}`}</span>
                    </React.Fragment>
                  }}
                /> 
              </div> <br />
              <div style={styles.flexB}>
                <FunctionField
                  label="Comments"
                  render={(b) => {
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Comments: </label>
                      <span class="tamDetalle2">{`${rental.booking.r_comments}`}</span>
                    </React.Fragment>
                  }}
                />
              </div> <br />
              <div style={styles.flexB}>
                <FunctionField
                  label="Allergy/Special Diet"
                  render={(b) => {
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Allergy/Special Diet: </label>
                      <span class="tamDetalle2">{`${rental.booking.r_allergy_special_diet || ''}`}</span>
                    </React.Fragment>
                  }}
                />
              </div> <br />
            </div>
            <div style={styles.leftColB}> 
              <div class="minusPadd" style={styles.flexB}>
                <h2 class="colorTitle">Rider info:</h2>
              </div>
              <div style={styles.flexB} >
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Name"
                          render={(b) => {
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Name: </label>
                              <span id="tourDate1" class="boldDetalle tamDetalle2">{`${rental.booking.r_first_name} ${rental.booking.r_last_name}`} </span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Email"
                          render={(b) => {
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Email: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_email}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div><br />
              <div style={styles.flexB}>
              <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftColB}>
                        <div style={styles.flexB}>
                          <FunctionField
                            label="Phone Number"
                            render={(b) => {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle"> Phone number: </label>
                                <span class="tamDetalle2"> Home {`${rental.booking.r_home_phone}`}  - </span>
                                <span class="tamDetalle2"> Work {`${rental.booking.r_work_phone}`}</span>
                              </React.Fragment>
                            }}
                          />
                        </div>
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                            label="Nickname"
                            render={(b) => {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle">Nickname: </label>
                                <span id="tourDate1" class="boldDetalle tamDetalle2">{`${ rental.booking.nickname != null ? rental.booking.nickname : ''}`} </span>
                              </React.Fragment>
                            }}
                          />
                      </div>
                    </div>
                  </div>
                </div> 
              </div>  <br />
              <div style={styles.flexB} >
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Address"
                          render={(b) => {
                            const state = isNil(rental.booking.r_state_province) ? "" : `${rental.booking.r_state_province}`
                            getCountry(rental.booking.r_country_id, 1)
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Address: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_address} ${rental.booking.r_zip}, ${rental.booking.r_city}, ${state}, `}</span>
                              <span class="tamDetalle2" id="countryD">{``}</span>
                            </React.Fragment>

                          }}
                        />
                      </div> <br />
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Nationality"
                          render={(b) => {
                            getCountry(rental.booking.r_nationality, 3)
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Nationality: </label>
                              <span id="nationalityD" class="tamDetalle2">{``}</span>
                            </React.Fragment>
                          }}
                        />
                      </div> <br />
                    </div>
                  </div>
                </div>
              </div>
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Occupation"
                          render={(b) => {
                            const ocupation = isNil(rental.booking.r_occupation)
                              ? "N/A"
                              : `${rental.booking.r_occupation}`
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Occupation: </label>
                              <span class="tamDetalle2">{`${ocupation}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div> <br />
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Languages Spoken"
                          render={(b) => {
                            const capitalize = compose(
                              join(""),
                              juxt([compose(toUpper, head), tail])
                            );
                            const languages = [
                              "english",
                              "spanish",
                              "german",
                              "french",
                              "portuguese",
                            ];
                            const lang = join(
                              ", ",
                              filter(
                                identity,
                                map((language) => {
                                  return prop(`r_${language}`, rental.booking)
                                    ? capitalize(language)
                                    : false;
                                }, languages)
                              )
                            );
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Languages spoken: </label>
                              <span class="tamDetalle2">{`${lang}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div> <br />
                    </div>
                  </div>
                </div>
              </div>
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Passport/ID"
                          render={(b) => {
                            const passport = isNil(rental.booking.r_passport) ? "N/A" : `${rental.booking.r_passport}`
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Passport/ID: </label>
                              <span class="tamDetalle2">{`${passport}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Driver's License"
                          render={(b) => {
                            const licen = isNil(rental.booking.r_license) ? "N/A" : `${rental.booking.r_license}`
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Driver's license: </label>
                              <span class="tamDetalle2">{`${licen}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="T-shirt size"
                          render={(b) => {
                            const shirtKey = rental.booking.r_shirt;
                            const licen = shirtKey && Number(shirtKey) > 0
                              ? (prop(shirtKey, shirtSize) || "N/A")
                              : "N/A";
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">T-shirt size: </label>
                              <span class="tamDetalle2">{`${licen}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> <br />
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Date of Birth"
                          render={(b) => {
                            const birtday = isNil(rental.booking.r_birthday) ? "N/A" : `${rental.booking.r_birthday}`
                            const fortmat = moment(birtday).format("DD-MM-YYYY")
                            const anio = moment().diff(moment(rental.booking.r_birthday), "years")
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Date of birth: </label>
                              <span class="tamDetalle2">{`${fortmat} --> ${anio} years`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div> <br />
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Height"
                          render={(b) => {
                            const unit = rental.booking.r_height_unit === 1 || rental.booking.r_height_unit === '1'? "ft" : "m";
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle" >Height: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_height} ${unit}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div> <br />
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Weight"
                          render={(b) => {
                            const unit = rental.booking.r_weight_unit === 1 || rental.booking.r_weight_unit === '1'? "lbs" : "kg";
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Weight: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_weight} ${unit}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
           
            
              <div class="minusPadd" style={styles.flexB}>
                <h2 class="colorTitle">Riding Experience</h2>
              </div>
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Years of Riding"
                          render={b => {
                            const experienceYears = parseInt(rental.booking.r_experience_years, 10);
                            let experienceYearsNumber = 0;
                            if (!Number.isNaN(experienceYears)) {
                              experienceYearsNumber = experienceYears.toString().length === 4 ? (new Date().getFullYear()) - experienceYears : experienceYears
                            }
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Years of riding: </label>
                              <span class="tamDetalle2">{`${experienceYearsNumber} years`}</span>
                            </React.Fragment>
                            //return `${experienceYearsNumber} years`;
                          }}
                        />
                      </div> <br />
                    </div>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Riding Last Year"
                          render={(b) => {
                            const unit =
                              rental.booking.r_experience_past_year_unit === 1 ? "km" : "miles";
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Riding last year: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_experience_past_year} ${unit}`}</span>
                            </React.Fragment>
                            //return `${rental.booking.r_experience_past_year} ${unit}`;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Average Ride Distance"
                          render={(b) => {
                            const unit =
                              rental.booking.r_experience_ride_distance_unit === 1
                                ? "km"
                                : "miles";
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Average ride distance: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_experience_ride_distance} ${unit}`}</span>
                            </React.Fragment>
                            //return `${rental.booking.r_experience_ride_distance} ${unit}`;
                          }}
                        />
                      </div> <br />
                    </div>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Riding Experience"
                          render={(b) => {
                            const capitalize = compose(
                              join(""),
                              juxt([compose(toUpper, head), tail])
                            );
                            const exp = ["street", "sweepers", "twisties", "track", "off_road"];
                            const data = join(
                              ", ",
                              filter(
                                identity,
                                map((exp) => {
                                  return prop(`r_${exp}`, rental.booking)
                                    ? capitalize(exp)
                                    : false;
                                }, exp)
                              )
                            );
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Riding experience: </label>
                              <span class="tamDetalle2">{`${data}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div> <br />
                    </div>
                  </div>
                </div>
              </div>
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Motorcycle(s) Owned"
                          render={(b) => {
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Motorcycle(s) owned: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_own_models}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="How did you find about us?"
                          render={(b) => {
                            const refer = GetRefe(rental)
                            let d = ''
                            if (refer != undefined) {
                              d = refer.name
                              // path(["driver", "referral", "name"], rental)
                            }
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">How did you find about us?: </label>
                              <span class="tamDetalle2">{`${d}`}</span>
                            </React.Fragment>
                            //return path(["driver", "referral", "name"], rental);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> 
            </div>
          </div> 
               <div class="minusPadd" style={styles.flexB}>
                <h2 class="colorTitle">Emergency contact</h2>
              </div>
              <div style={styles.flexB}>
                <FunctionField
                  label="Name"
                  render={(b) => {
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Name: </label>
                      <span class="tamDetalle2">{`${rental.booking.r_emergency_name}`}</span>
                    </React.Fragment>
                  }}
                />
              </div>
              <div style={styles.flexB}>
                <FunctionField
                  label="Relationship"
                  render={(b) => {
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Relationship: </label>
                      <span class="tamDetalle2">{`${rental.booking.r_emergency_relationship}`}</span>
                    </React.Fragment>
                  }}
                />
              </div> 
              <div style={styles.flexB}>
                <FunctionField
                  label="Number"
                  render={(b) => {
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Number: </label>
                      <span class="tamDetalle2">{`${rental.booking.r_emergency_phone}`}</span>
                    </React.Fragment>
                  }}
                />
              </div> 
          <FunctionField
            label="Passenger"
            render={(b) => {
              if (!isNil(rental.booking.p_first_name)) {
                return <React.Fragment>
                  <div style={styles.leftColB}>
                    <div class="minusPadd" style={styles.flexB}>
                      <h2 class="colorTitle">Rider info:</h2>
                    </div>
                    <div style={styles.flexB} >
                      <div style={styles.flexPaddingI}>
                        <div style={styles.flex}>
                          <div style={styles.leftColB}>
                            <div style={styles.flexB}>
                              <FunctionField
                                label="Name"
                                render={(b) => {
                                  return <React.Fragment>
                                    <label class="colorDetalle tamDetalle">Name: </label>
                                    <span id="tourDate1" class="boldDetalle tamDetalle2">{`${rental.booking.p_first_name} ${rental.booking.p_last_name}`} </span>
                                  </React.Fragment>
                                }}
                              />
                            </div>
                          </div>
                          <div style={styles.leftColB}>
                            <div style={styles.flexB}>
                              <FunctionField
                                label="Email"
                                render={(b) => {
                                  return <React.Fragment>
                                    <label class="colorDetalle tamDetalle">Email: </label>
                                    <span class="tamDetalle2">{`${rental.booking.p_email}`}</span>
                                  </React.Fragment>
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div><br />
                    <div style={styles.flexB} >
                      <div style={styles.flexPaddingI}>
                        <div style={styles.flex}>
                          <div style={styles.leftColB}>
                            <div style={styles.flexB}>
                              <FunctionField
                                label="Phone Number"
                                render={(b) => {
                                  return <React.Fragment>
                                    <label class="colorDetalle tamDetalle"> Phone number: </label>
                                    <span class="tamDetalle2"> Home {`${rental.booking.p_home_phone}`}  - </span>
                                    <span class="tamDetalle2"> Work {`${rental.booking.p_work_phone}`}</span>
                                  </React.Fragment>
                                }}
                              />
                            </div>  <br />
                          </div>
                          <div style={styles.leftColB}>
                            <div style={styles.flexB}>
                              <FunctionField
                                label="Date of Birth"
                                render={(b) => {
                                  const birtday = isNil(rental.booking.p_birthday) ? "N/A" : `${rental.booking.p_birthday}`
                                  const fortmat = moment(birtday).format("DD-MM-YYYY")
                                  const anio = moment().diff(moment(rental.booking.p_birthday), "years")
                                  return <React.Fragment>
                                    <label class="colorDetalle tamDetalle">Date of birth: </label>
                                    <span class="tamDetalle2">{`${fortmat} --> ${anio} years`}</span>
                                  </React.Fragment>
                                }}
                              />
                            </div> <br />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={styles.flexB} >
                      <div style={styles.flexPaddingI}>
                        <div style={styles.flex}>
                          <div style={styles.leftColB}>
                            <div style={styles.flexB}>
                              <FunctionField
                                label="Address"
                                render={(b) => {
                                  const state = isNil(rental.booking.p_state_province) ? "" : `${rental.booking.p_state_province}`
                                  getCountry(rental.booking.p_country_id, 1)
                                  return <React.Fragment>
                                    <label class="colorDetalle tamDetalle">Address: </label>
                                    <span class="tamDetalle2">{`${rental.booking.p_address} ${rental.booking.p_zip}, ${rental.booking.p_city}, ${state}, `}</span>
                                    <span class="tamDetalle2" id="countryD">{``}</span>
                                  </React.Fragment>

                                }}
                              />
                            </div> <br />
                          </div>
                          <div style={styles.leftColB}>
                            <div style={styles.flexB}>
                              <FunctionField
                                label="Nationality"
                                render={(b) => {
                                  getCountry(rental.booking.r_nationality, 3)
                                  return <React.Fragment>
                                    <label class="colorDetalle tamDetalle">Nationality: </label>
                                    <span id="nationalityD" class="tamDetalle2">{``}</span>
                                  </React.Fragment>
                                }}
                              />
                            </div> <br />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={styles.flexB}>
                      <div style={styles.flexPaddingI}>
                        <div style={styles.flex}>
                          <div style={styles.leftColB}>
                            <div style={styles.flexB}>
                              <FunctionField
                                label="Occupation"
                                render={(b) => {
                                  const ocupation = isNil(rental.booking.p_occupation)
                                    ? "N/A"
                                    : `${rental.booking.p_occupation}`
                                  return <React.Fragment>
                                    <label class="colorDetalle tamDetalle">Occupation: </label>
                                    <span class="tamDetalle2">{`${ocupation}`}</span>
                                  </React.Fragment>
                                }}
                              />
                            </div> <br />
                          </div>
                          <div style={styles.leftColB}>
                            <div style={styles.flexB}>
                              <FunctionField
                                label="Languages Spoken"
                                render={(b) => {
                                  const capitalize = compose(
                                    join(""),
                                    juxt([compose(toUpper, head), tail])
                                  );
                                  const languages = [
                                    "english",
                                    "spanish",
                                    "german",
                                    "french",
                                    "portuguese",
                                  ];
                                  const lang = join(
                                    ", ",
                                    filter(
                                      identity,
                                      map((language) => {
                                        return prop(`p_${language}`, rental.booking)
                                          ? capitalize(language)
                                          : false;
                                      }, languages)
                                    )
                                  );
                                  return <React.Fragment>
                                    <label class="colorDetalle tamDetalle">Languages spoken: </label>
                                    <span class="tamDetalle2">{`${lang}`}</span>
                                  </React.Fragment>
                                }}
                              />
                            </div> <br />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={styles.flexB}>
                      <div style={styles.flexPaddingI}>
                        <div style={styles.flex}>
                          <div style={styles.leftColB}>
                            <div style={styles.flexB}>
                              <FunctionField
                                label="Passport/ID"
                                render={(b) => {
                                  const passport = isNil(rental.booking.p_passport) ? "N/A" : `${rental.booking.p_passport}`
                                  return <React.Fragment>
                                    <label class="colorDetalle tamDetalle">Passport/ID: </label>
                                    <span class="tamDetalle2">{`${passport}`}</span>
                                  </React.Fragment>
                                }}
                              />
                            </div>
                          </div>
                          <div style={styles.leftColB}>
                            <div style={styles.flexB}>
                              <FunctionField
                                label="Driver's License"
                                render={(b) => {
                                  const licen = isNil(rental.booking.p_license) ? "N/A" : `${rental.booking.p_license}`
                                  return <React.Fragment>
                                    <label class="colorDetalle tamDetalle">Driver's license: </label>
                                    <span class="tamDetalle2">{`${licen}`}</span>
                                  </React.Fragment>
                                }}
                              />
                            </div>
                          </div> 
                        </div>
                      </div>
                    </div> <br />
                    <div style={styles.flexB}>
                      <div style={styles.flexPaddingI}>
                        <div style={styles.flex}>
                          <div style={styles.leftColB}>
                            <div style={styles.flexB}>
                              <FunctionField
                                label="Height"
                                render={(b) => {
                                  const unit = rental.booking.p_height_unit === 1 ? "m" : "ft";
                                  return <React.Fragment>
                                    <label class="colorDetalle tamDetalle" >Height: </label>
                                    <span class="tamDetalle2">{`${rental.booking.p_height} ${unit}`}</span>
                                  </React.Fragment>
                                }}
                              />
                            </div> <br />
                          </div>
                          <div style={styles.leftColB}>
                            <div style={styles.flexB}>
                              <FunctionField
                                label="Weight"
                                render={(b) => {
                                  const unit = rental.booking.p_height_unit === 1 ? "kg" : "lbs";
                                  return <React.Fragment>
                                    <label class="colorDetalle tamDetalle">Weight: </label>
                                    <span class="tamDetalle2">{`${rental.booking.p_weight} ${unit}`}</span>
                                  </React.Fragment>
                                }}
                              />
                            </div>
                          </div>
                          <div style={styles.rightCol}>
                            <div style={styles.flexB}>
                              <FunctionField
                                label="T-shirt size"
                                render={(b) => {
                                  const shirtKey = rental.booking.p_shirt;
                                  const licen = shirtKey && Number(shirtKey) > 0
                                    ? (prop(shirtKey, shirtSize) || "N/A")
                                    : "N/A";
                                  return <React.Fragment>
                                    <label class="colorDetalle tamDetalle">T-shirt size: </label>
                                    <span class="tamDetalle2">{`${licen}`}</span>
                                  </React.Fragment>
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              }
            }}
          />
          <div style={styles.flexB}>
            {/* <h2 class="colorTitle">Previous Tours</h2> */}
            <FunctionField
              label="Previous Tours"
              render={(b) => {
                const stateGroup = isNil(rental.booking.r_tour_group) ? "N/A" : `${rental.booking.r_tour_group}`
                return <React.Fragment>
                  <h2 class="colorTitle tamDetalle">Previous tours: </h2>
                  <span class="tamDetalle2">{`${stateGroup}`}</span>
                </React.Fragment>
              }}
            />
          </div>
          <div style={styles.flexB}>
            <PastImtbTours record={rental} />
          </div>
        </div>
      } />
  </React.Fragment>
);


const RentalShowActions = () => {
  return "";
};

export const RentalShow = (props) => (
  <Show {...props} actions={<RentalShowActions />} title="Tour (ID)">
    <TabbedShowLayout>
      <Tab label="Payments">
        <ReferenceManyField
          label="Payments"
          reference="payments"
          target="type_id"
          filter={{ type: "rental" }}
        >
          <Datagrid>
            <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} source="date" />
            <NumberField source="value" />
            <ShowButton label="Charges" />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);



// WEBPACK FOOTER //
// ./src/resources/pending_tours.js